import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CreditorDetailsHttpService } from './services/creditor-details-http.service';
import { CreditorDetailsEffects } from './effects/creditor-details.effects';
import * as CreditorDetailsReducers from './reducers/creditor-details.reducers';

@NgModule({
  providers: [
    CreditorDetailsHttpService,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature('CreditorDetails', CreditorDetailsReducers.reducer),
    EffectsModule.forFeature([CreditorDetailsEffects])
  ]
})
export class CreditorDetailsModule { }
